export const GET_INSURANCE_COMPANY_DATA =  'GET_INSURANCE_COMPANY_DATA'
export const GET_INSURANCE_COMPANY_DATA_SUCCESS =  'GET_INSURANCE_COMPANY_DATA_SUCCESS'
export const GET_INSURANCE_COMPANY_DATA_ERROR =  'GET_INSURANCE_COMPANY_DATA_ERROR'

export const GET_INSURANCE_COMPANY_PAGE_DATA =  'GET_INSURANCE_COMPANY_PAGE_DATA'
export const GET_INSURANCE_COMPANY_PAGE_DATA_SUCCESS =  'GET_INSURANCE_COMPANY_PAGE_DATA_SUCCESS'
export const GET_INSURANCE_COMPANY_PAGE_DATA_ERROR =  'GET_INSURANCE_COMPANY_PAGE_DATA_ERROR'